import React from 'react';

export const CanvaSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_1737_5841)">
				<rect width="32" height="32" rx="8" fill="#00C4CC" />
				<rect width="32" height="32" rx="8" fill="#00C4CC" />
				<rect width="32" height="32" rx="8" fill="#00C4CC" />
				<rect width="32" height="32" rx="8" fill="#00C4CC" />
				<rect width="32" height="32" rx="8" fill="#00C4CC" />
				<path
					d="M22.6962 18.8754C22.5778 18.8754 22.4735 18.9755 22.365 19.1939C21.1399 21.6781 19.024 23.4358 16.5754 23.4358C13.7441 23.4358 11.9908 20.88 11.9908 17.3492C11.9908 11.3683 15.3232 7.91022 18.2502 7.91022C19.6179 7.91022 20.4532 8.76974 20.4532 10.1375C20.4532 11.7609 19.5309 12.6204 19.5309 13.193C19.5309 13.45 19.6908 13.6056 20.0078 13.6056C21.2814 13.6056 22.7762 12.1421 22.7762 10.0747C22.7762 8.07013 21.0315 6.59668 18.1046 6.59668C13.2673 6.59668 8.96826 11.0813 8.96826 17.2863C8.96826 22.0894 11.711 25.2633 15.9429 25.2633C20.4346 25.2633 23.0318 20.7944 23.0318 19.3438C23.0318 19.0226 22.8676 18.8754 22.6962 18.8754Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1737_5841">
					<rect width="32" height="32" rx="8" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
